export default () => {
  const topInfo = document.querySelector('.top-info');
  const contentBlock = topInfo.querySelector('.content-block');
  if(contentBlock) {
    if (contentBlock.children.length <= 1) {
      topInfo.classList.add('one-cv');
      topInfo.classList.remove('two-cv');
    }
  }
}